/* eslint-disable no-nested-ternary */
import { Button, Chip, Divider, Grid, MenuItem } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import {
  setAffiliateAction,
} from '@webapps/business';
import {
  ModalSideBar,
  Pagination,
  PaginationNumbers,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import Modal from 'components/Modal';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import { default as ModalLarge } from 'components/ModalLarge';
import ProfilName from 'components/Profil/Components/ProfilName';
import ProfilAffiliate from 'components/Profil/ProfilAffiliate';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useLocation from 'react-router-dom';

import CreateAnnonce from '../../AnnoncesCandidats/components/CreateAnnonce';
import Affiliate from './Affiliate';
import CandidatsCard from './CandidatsCard';
import TransfertDocument from './TransfertDocument';

const Candidats = ({
  candidatures,
  totalElements,
  offres,
  contractTypes,
  refetchCandidature,
  refetch,
  handleAcceptedCount,
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();

  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [idSelect, setIdSelect] = useState(0);
  const [selectedAffiliation, setSelectedAffiliation] = useState();
  const [viewAffiliation, setViewAffiliation] = useState(false);
  const [viewCancelAffiliation, setViewCancelAffiliation] = useState(false);
  const [viewTransfert, setViewTransfert] = useState(false);

  const STATUS = [
    { label: 'Tous les statuts', value: 'all' },
    { label: 'En attente du candidat', value: 'CREATED' },
    { label: 'En attente de votre validation ⚠️', value: 'ACCEPTED' },
    { label: 'Refusé par vous', value: 'REJECTED' },
    { label: 'En attente de document(s)', value: 'HALF-REJECTED' },
    { label: 'Annulé par vous', value: 'CANCELED' },
    { label: 'Annulé par le candidat', value: 'BROKEN' },
    { label: 'Terminé', value: 'ENCLOSED' },
  ];

  const searchStatus = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setStatus('') : setStatus(e.target.value);
      setPage(1);
    }
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewProfil, setViewProfil] = useState(false);
  const { push } = useRouter();
  const [openCreateAnnonce, setOpenCreateAnnonce] = useState(false);
  const [stepModal, setStepModal] = useState(1);

  const handleOpenCreateAnnonce = () => {
    setOpenCreateAnnonce(true);
  };

  const handleCloseCreateAnnonce = () => {
    setOpenCreateAnnonce(false);
  };

  const handleViewCvtheque = () => {
    push(ROUTES_PATH.CVTHEQUE_BUSINESS, { params: { id: idUser } });
  };

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const viewCV = (id) => {
    setIdSelect(id);
    handleOpenViewProfil();
  };

  const handleOpenAffiliation = (item) => {
    setViewAffiliation(true);
    setSelectedAffiliation(item);
  };

  const handleOpenCancelAffiliation = (item) => {
    setViewCancelAffiliation(true);
    setSelectedAffiliation(item);
  };

  const handleCloseAffiliation = () => {
    setViewAffiliation(false);
  };

  const handleCloseCancelAffiliation = () => {
    setViewCancelAffiliation(false);
  };

  const handleOpenViewTransfert = () => {
    setViewTransfert(true);
  };
  const handleCloseViewTransfert = () => {
    setViewTransfert(false);
  };

  const transfert = (item) => {
    setSelectedAffiliation(item);
    handleOpenViewTransfert();
  };

  useEffect(() => {
    if (candidatures.length && selectedAffiliation) {
      candidatures.map(
        (item) =>
          item?.id === selectedAffiliation?.id && setSelectedAffiliation(item)
      );
    }
  }, [candidatures]);

  const { addToast } = useToast();

  const {
    error: errorAffiliateAction,
    isLoading: isLoadingAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(setAffiliateAction);

  const cancelAffiliate = async () => {
    await mutateSetAffiliateAction({
      idAffiliate: selectedAffiliation?.id,
      action: 'cancel',
    });
  };

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Des actions sont nécessaires pour finaliser l'affiliation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: 'Affiliation annulée avec succès',
      });
      handleCloseCancelAffiliation();
      refetchCandidature();
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);

  const filteredCandidatures = candidatures?.filter((item) =>
    ['ENCLOSED'].includes(item?.status)
  );
  const ITEMS_PER_PAGE = 12;
  const indexOfLastItem = page * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = filteredCandidatures.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  useEffect(() => {
    handleAcceptedCount(filteredCandidatures?.length);
  }, [filteredCandidatures]);

  return (
    <Grid item xs
      className={
        classes.container
      }
    >
      <div
        className={css({
          // maxHeight: ITEMS_PER_PAGE < filteredCandidatures.length ? 'calc(100vh - 75px - 243px)' : 'calc(100vh - 75px - 193px)',
          '@media only screen and (max-width: 1023px)': {
            // maxHeight: '100%',
          },
          overflow: 'auto',
          height: '100%'
        })}
      >       {!filteredCandidatures?.length ? (
        <>
          {/* Desktop */}
          <Grid
            container
            className={css({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '@media screen and (max-width: 768px)': { display: 'none' },
            })}
            style={{ height: '100%' }}
          >
            <Grid
              item
              xs={12}
              className={css({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#F3F7FF',
                borderRadius: 12,
              })}
              style={{ height: '100%' }}
            >
              <Grid
                item
                className={css({
                  backgroundColor: '#FFFFFF',
                  borderRadius: 12,
                  padding: '30.0px',
                  '@media screen and (max-width: 768px)': {
                    padding: '20px',
                  },
                })}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <h1 className={cx(css({ margin: '0px 0px 30px 0px' }), global.title)}>
                    {' '}
                    Commencez à construire votre réseau d'affiliation
                  </h1>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      columnGap: '20px',
                      width: '500px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.btn}
                        fullWidth
                        onClick={handleOpenCreateAnnonce}
                        disableElevation={true}
                      >
                        Publier une offre
                      </Button>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        1. Complétez vos critères
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        2. Devenez visible pour tous
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        3. Obtenez des candidatures
                      </p>
                    </div>

                    <p>ou</p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        fullWidth
                        className={classes.btn}
                        onClick={handleViewCvtheque}
                        disableElevation={true}
                      >
                        Avec la CVthèque
                      </Button>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        1. Filtrez selon vos critères
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        2. Dans les écoles ou non.
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        3. Obtenez des profils qualifiés.
                      </p>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          {/* Mobile */}
          <Grid
            container
            className={css({
              display: 'none',
              justifyContent: 'center',
              alignItems: 'center',
              '@media screen and (max-width: 768px)': { display: 'flex' },
            })}
          >
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
                backgroundColor: '#F3F7FF',
                borderRadius: 12,
              }}
            >
              <Grid
                item
                className={css({
                  backgroundColor: '#FFFFFF',
                  borderRadius: 12,
                  padding: '30.0px',
                  '@media screen and (max-width: 768px)': {
                    padding: '20px',
                  },
                })}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <h1 className={cx(css({ margin: '0px 0px 30px 0px' }), global.title)}>
                    {' '}
                    Commencez à construire votre réseau d'affiliation
                  </h1>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      columnGap: '20px',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        1. Complétez vos critères.
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        2. Devenez visible pour tous.
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}
                        style={{ marginBottom: '20px' }}
                      >
                        3. Obtenez des candidatures
                      </p>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={handleOpenCreateAnnonce}
                        disableElevation={true}
                        className={classes.btn}
                      >
                        Publier une offre
                      </Button>
                    </div>
                    <p>ou</p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        1. Filtrez selon vos critères.
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}>
                        2. Dans les écoles ou non.
                      </p>
                      <p className={cx(classes.stepStyles, global.infoText)}
                        style={{ marginBottom: '20px' }}
                      >
                        3. Obtenez des profils qualifiés.
                      </p>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={handleViewCvtheque}
                        className={classes.btn}
                      >
                        Avec la CVthèque
                      </Button>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid
          container
          className={css({
            padding: spacing(0, 0, 2.5, 2.5),
            backgroundColor: '#F3F7FF',
            borderRadius: 10,
          })}
        >
          {currentItems?.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <CandidatsCard
                item={item}
                cancelAffiliation={() => handleOpenCancelAffiliation(item)}
                transfertDocument={() => transfert(item)}
                viewAffiliation={() => handleOpenAffiliation(item)}
                viewMember={() => viewCV(item?.student?.id)}
              />
            </Grid>
          ))}
        </Grid>
      )}
      </div>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={ITEMS_PER_PAGE}
        totalCount={filteredCandidatures.length}
        noMargin={true}
      />
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={idSelect} />}
      >
        <ProfilAffiliate id={idSelect} />
      </ModalSideBar>
      <Modal
        onCancel={handleCloseAffiliation}
        open={viewAffiliation}
        subTitle="Finalisez l'affiliation avec votre futur étudiants
        pour l'intégrer dans une classe existante"
        title="Finaliser l'affiliation"
        withStep={false}
      >
        <Affiliate
          affiliation={selectedAffiliation}
          close={handleCloseAffiliation}
          refetchCandidature={refetchCandidature}
        />
      </Modal>
      <Modal
        nbStep={5}
        onCancel={handleCloseCreateAnnonce}
        open={openCreateAnnonce}
        step={stepModal}
        title={intl.formatMessage({
          id: 'business.annoncesCandidats.publierAnnonceSubTitle',
        })}
      >
        <CreateAnnonce
          onChangeStepModal={setStepModal}
          onClose={handleCloseCreateAnnonce}
          refetchOffre={refetch}
        />
      </Modal>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={cancelAffiliate}
        isLoading={isLoadingAffiliateAction}
        onClose={handleCloseCancelAffiliation}
        open={viewCancelAffiliation}
        title="Annuler l'affiliation"
      >
        Êtes-vous sûr de vouloir annuler l'affiliation
      </ModalConfirm>
      <Modal
        onCancel={handleCloseViewTransfert}
        open={viewTransfert}
        subTitle="Transferer un document"
        title="Finaliser l'affiliation"
        withStep={false}
      >
        <TransfertDocument
          close={handleCloseViewTransfert}
          data={selectedAffiliation?.additionalFiles}
        />
      </Modal>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  stepStyles: {
    margin: '10px 0 0 0',
  },
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  btn: {
    marginBottom: '20px',
  }
});

export default Candidats;
